// ** Lesson materials: downloadable files for the active lesson (style-v3)
import React from "react";

import OpenInNew from "mdi-material-ui/OpenInNew";
import CloudDownloadOutline from "mdi-material-ui/CloudDownloadOutline";

import Box from "@mui/material/Box";
import { file_get } from "../../../../api/product-download";

function Content({ content, isMobile, authData }) {
  if (content === undefined || content === null || content === "" || content?.length === 0) return null;

  const requestDownloadUrl = async (file, justUrl = true) => {
    const fileResponse = await dbGetLessonFile(authData, file);

    if (fileResponse.status === true && justUrl === true) {
      return fileResponse.data;
    }

    if (fileResponse.status === true && justUrl !== true) {
      const safeUrl = fileResponse.data;

      // Open link in new tab
      const a = document.createElement("a");
      a.href = safeUrl;
      a.target = "_blank";
      a.click();
    }
  };

  const dbGetLessonFile = (auth, file) => {
    return new Promise((resolve) => {
      try {
        file_get(auth, file)
          .then((res) => resolve({ status: true, data: res.data }))
          .catch((err) => resolve({ status: false, data: err }));
      } catch (error) {
        resolve({ status: false, data: error });
      }
    });
  };

  return (
    <Box className="lesson-materials" sx={{ px: 4, pt: 2, pb: 1 }}>
      <div className="lesson-section-label">
        Materiais
        <span className="lesson-section-label__count">{content.length}</span>
      </div>
      <div className="lesson-materials__list">
        {content.map((item) => {
          const fileExtension = item?.filename?.split(".").pop();
          return (
            <div className="lesson-material" key={item.key}>
              <span className="lesson-material__badge">{(fileExtension || "?").toUpperCase()}</span>
              <a className="lesson-material__name" href={item.url} target="_blank" rel="noreferrer">
                {urlElipsis(item.name, isMobile)}
                <OpenInNew />
              </a>
              <button
                type="button"
                className={`lesson-material__dl ${isMobile ? "lesson-material__dl--icon" : ""}`}
                onClick={() => (isMobile ? requestDownloadUrl(item.url) : requestDownloadUrl(item.url, false))}
              >
                <CloudDownloadOutline />
                {!isMobile && "Download"}
              </button>
            </div>
          );
        })}
      </div>
      {/* <PDFDrawer visible={pdfDrawer.visible} data={pdfDrawer.data} close={() => setPdfDrawer({ visible: false })} /> */}
    </Box>
  );
}

// HELPERS
const urlElipsis = (url, isMobile) => {
  try {
    const maxLen = isMobile ? 25 : 50;
    if (url.length > maxLen) {
      return "..." + url.substr(url.length - maxLen);
    }
    return url;
  } catch (error) {
    return url;
  }
};

export default Content;
